<script>
    // import {flow_info, flow_stack} from './stores.js';
    import{flow_steps, user_data} from './stores.js';
    import { onMount } from "svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    // import Listcomponent from './components/listcomponent.svelte';
    import Listcomponent from './components/listcomponent.svelte';
    export let listdata = [
        {s: true, t: "I'm researching general information", cbf:()=>{$flow_steps.current_flow = "drp"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1; $user_data.whereinprocess = "I'm researching general information";}},
        {s: false, t: "I'm currently going to open houses", cbf:()=>{$flow_steps.current_flow = "drp"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1; $user_data.whereinprocess = "I'm currently going to open houses";}},
        {s: false, t: "I'm making offers on homes", cbf:()=>{$flow_steps.current_flow = "dbp"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1;$user_data.whereinprocess = "I'm making offers on homes";}},
        {s: false, t: "I have signed a purchase contract", cbf:()=>{$flow_steps.current_flow = "dgp"; $flow_steps.current_next_loc = 3; $flow_steps.current_prev_loc = 1; $user_data.whereinprocess = "I have signed a purchase contract";}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
show_icon_card={true}
>
    <Progresscomponent 
    title="Where in the process are you?"
    override_urlcheck={true}
    show_next_button={false}
    >
    <Listcomponent
        bind:listdata={listdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>